module.exports = __webpack_public_path__ + "img/button_guide.37d5ca8c.png";